import styled from 'styled-components';

export const LoadingContainer = styled.div`
  position: fixed;
  height: 100%;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 901;
`;

export const LoadingDisabler = styled.div`
  background: #FFF;
  filter: alpha(opaticy=45);
  height: 110%;
  position: fixed;
  opacity: .45;
  width: 110%;
  z-index: 900;
`;

export const SpinnerContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 45%;
  z-index: 901;
`;
